import { TimeZone } from './types'

export const TimeZones: TimeZone[] = [
  {
    id: '4cf1d207-9656-4edf-a76d-95fbd418780e',
    name: 'Africa/Abidjan',
    offset: '+00:00',
  },
  {
    id: '621b62d9-38f1-4734-9232-3420c86e315c',
    name: 'Africa/Accra',
    offset: '+00:00',
  },
  {
    id: '6d89c459-e092-4a3e-abaf-a4a64fdd5d26',
    name: 'Africa/Addis_Ababa',
    offset: '+03:00',
  },
  {
    id: '110b5fb6-7ab6-4567-a8d8-d53016cbb35d',
    name: 'Africa/Algiers',
    offset: '+01:00',
  },
  {
    id: 'ebdc3cf0-91f7-4815-aeb0-90aa3cce7cb7',
    name: 'Africa/Asmara',
    offset: '+03:00',
  },
  {
    id: 'c66c21e4-bc58-455f-b424-39ee6f91bf2f',
    name: 'Africa/Asmera',
    offset: '+03:00',
  },
  {
    id: '9732c5a9-63a7-4f27-8e8e-de7181a1b9b9',
    name: 'Africa/Bamako',
    offset: '+00:00',
  },
  {
    id: '89ba8a81-b654-4236-88db-09e64cb6707f',
    name: 'Africa/Bangui',
    offset: '+01:00',
  },
  {
    id: 'e5b11d2b-19e1-4a31-9167-615f570fb0eb',
    name: 'Africa/Banjul',
    offset: '+00:00',
  },
  {
    id: '3cbc3cdc-abcd-49d7-9a07-84a463f48031',
    name: 'Africa/Bissau',
    offset: '+00:00',
  },
  {
    id: '1a17706c-affb-49d4-8fc6-397302e87727',
    name: 'Africa/Blantyre',
    offset: '+02:00',
  },
  {
    id: 'e527dffe-1b18-43e0-a0f1-7c1e9c3cdaa2',
    name: 'Africa/Brazzaville',
    offset: '+01:00',
  },
  {
    id: 'd95028d9-1b42-497d-b6da-60541ac7bc7b',
    name: 'Africa/Bujumbura',
    offset: '+02:00',
  },
  {
    id: '49e8c1e9-b5cc-4603-9d82-6c3ce5dabea2',
    name: 'Africa/Cairo',
    offset: '+02:00',
  },
  {
    id: '98f4097d-e4ab-4ae3-a49b-0fbec6c36862',
    name: 'Africa/Casablanca',
    offset: '+01:00',
  },
  {
    id: '3b6226a4-a65f-4bc3-92a1-43fd6a9f7eac',
    name: 'Africa/Ceuta',
    offset: '+02:00',
  },
  {
    id: '5bd0b54c-1933-484b-8aa4-0680ccc04be0',
    name: 'Africa/Conakry',
    offset: '+00:00',
  },
  {
    id: 'f434c859-d972-4734-adcf-fa3c48f43ffe',
    name: 'Africa/Dakar',
    offset: '+00:00',
  },
  {
    id: '22a23b36-7670-4df5-82e3-43b1b779060e',
    name: 'Africa/Dar_es_Salaam',
    offset: '+03:00',
  },
  {
    id: '3dddc8b2-ce92-476c-a254-8f067c19d702',
    name: 'Africa/Djibouti',
    offset: '+03:00',
  },
  {
    id: '95bbabe3-5a75-4b7b-8860-4bd85d5a4edd',
    name: 'Africa/Douala',
    offset: '+01:00',
  },
  {
    id: 'fb2e5c56-0e42-4f48-8175-e8c78d289f08',
    name: 'Africa/El_Aaiun',
    offset: '+01:00',
  },
  {
    id: '4b12888d-094e-418f-bb35-871fe280f849',
    name: 'Africa/Freetown',
    offset: '+00:00',
  },
  {
    id: 'ddfc16ac-8a82-4e24-b7af-4f9fc9cbc669',
    name: 'Africa/Gaborone',
    offset: '+02:00',
  },
  {
    id: 'f5a521d0-64b5-454c-9673-87d265ff1ca1',
    name: 'Africa/Harare',
    offset: '+02:00',
  },
  {
    id: 'f6307f02-20b9-4239-9b46-ccc324d49733',
    name: 'Africa/Johannesburg',
    offset: '+02:00',
  },
  {
    id: '8174f90b-2220-48cf-89c1-f7224755ee9f',
    name: 'Africa/Juba',
    offset: '+03:00',
  },
  {
    id: '5d664b3e-503a-4ee2-b526-130eaccbc870',
    name: 'Africa/Kampala',
    offset: '+03:00',
  },
  {
    id: '5a0d49c5-1406-458a-a052-c98c4376c1b7',
    name: 'Africa/Khartoum',
    offset: '+02:00',
  },
  {
    id: '0808c868-be83-4801-bfbf-458f0cc42e0e',
    name: 'Africa/Kigali',
    offset: '+02:00',
  },
  {
    id: '38d27bc5-1522-4fd4-94de-2d2704c22d44',
    name: 'Africa/Kinshasa',
    offset: '+01:00',
  },
  {
    id: '714f07a5-56a4-428c-b785-de441a7b0265',
    name: 'Africa/Lagos',
    offset: '+01:00',
  },
  {
    id: '305cb446-0b42-401e-850e-b165b648c3d1',
    name: 'Africa/Libreville',
    offset: '+01:00',
  },
  {
    id: '7d913aef-504e-4a83-8ecb-84180d585c7a',
    name: 'Africa/Lome',
    offset: '+00:00',
  },
  {
    id: '88bf84aa-d100-43ea-8094-4ab8adc07585',
    name: 'Africa/Luanda',
    offset: '+01:00',
  },
  {
    id: '567725bc-2bee-42d7-8648-4bf9473ebe65',
    name: 'Africa/Lubumbashi',
    offset: '+02:00',
  },
  {
    id: '185e458a-863f-4a3d-8073-53137498267d',
    name: 'Africa/Lusaka',
    offset: '+02:00',
  },
  {
    id: '7191f72a-de37-4065-9c5a-435413a388c4',
    name: 'Africa/Malabo',
    offset: '+01:00',
  },
  {
    id: 'c76ad27c-bdd7-40e5-a1d7-c1ab43c41a9c',
    name: 'Africa/Maputo',
    offset: '+02:00',
  },
  {
    id: 'f514ffc5-727a-4e4d-9bac-7a28c2a061d6',
    name: 'Africa/Maseru',
    offset: '+02:00',
  },
  {
    id: '4661ceb6-fd9e-4f86-8bd7-b89b2228fb54',
    name: 'Africa/Mbabane',
    offset: '+02:00',
  },
  {
    id: '46bc04b8-e1ca-4acc-8c8c-d1f6313f68f9',
    name: 'Africa/Mogadishu',
    offset: '+03:00',
  },
  {
    id: '0e915393-20f0-4a07-896f-8c6ff19a811e',
    name: 'Africa/Monrovia',
    offset: '+00:00',
  },
  {
    id: '5994c327-9538-42d3-9823-4e03c41de935',
    name: 'Africa/Nairobi',
    offset: '+03:00',
  },
  {
    id: '83964ab2-b9c9-48c3-aa90-66283dabdb02',
    name: 'Africa/Ndjamena',
    offset: '+01:00',
  },
  {
    id: '86f1b35a-ffa6-4bea-b4b5-95cb9503b223',
    name: 'Africa/Niamey',
    offset: '+01:00',
  },
  {
    id: '884b691f-4c9e-4928-883e-10a287783f1b',
    name: 'Africa/Nouakchott',
    offset: '+00:00',
  },
  {
    id: 'cab394d3-5b7f-4380-bfc9-c3318156d67d',
    name: 'Africa/Ouagadougou',
    offset: '+00:00',
  },
  {
    id: '4b23581e-90ad-47a9-96fd-21c2697c2720',
    name: 'Africa/Porto-Novo',
    offset: '+01:00',
  },
  {
    id: '04c1378b-853a-4d78-983e-665777c769bf',
    name: 'Africa/Sao_Tome',
    offset: '+00:00',
  },
  {
    id: '5b5b5fbc-37ee-414a-8d09-6e271ddfce39',
    name: 'Africa/Timbuktu',
    offset: '+00:00',
  },
  {
    id: '5a24066f-27ed-4b72-ba46-529c43f06ba3',
    name: 'Africa/Tripoli',
    offset: '+02:00',
  },
  {
    id: '8be60021-a51a-40ab-b633-6e96f1945c70',
    name: 'Africa/Tunis',
    offset: '+01:00',
  },
  {
    id: 'fbd5df09-fed4-46b7-ba05-b8cfe76501c7',
    name: 'Africa/Windhoek',
    offset: '+02:00',
  },
  {
    id: 'c7a57537-9f9b-493c-9f65-d10056a37ce9',
    name: 'America/Adak',
    offset: '-0-9:00',
  },
  {
    id: '8cbd75ab-49a2-4dad-a0f1-e73abb4a7e21',
    name: 'America/Anchorage',
    offset: '-0-8:00',
  },
  {
    id: '6c8b1ace-35f0-4a45-baf1-3f07a4f82efd',
    name: 'America/Anguilla',
    offset: '-0-4:00',
  },
  {
    id: '44f326a1-108b-4cbc-afc6-49b58f249651',
    name: 'America/Antigua',
    offset: '-0-4:00',
  },
  {
    id: '5b490fd9-2989-4e80-84fb-a486be7d554b',
    name: 'America/Araguaina',
    offset: '-0-3:00',
  },
  {
    id: 'd0837e33-1fbd-4eaf-805f-61db163c96ed',
    name: 'America/Argentina/Buenos_Aires',
    offset: '-0-3:00',
  },
  {
    id: 'bc6c010e-9910-48c8-9528-04deab7fc6a5',
    name: 'America/Argentina/Catamarca',
    offset: '-0-3:00',
  },
  {
    id: '74c72938-42b2-4a1b-a226-3194800e4d1e',
    name: 'America/Argentina/ComodRivadavia',
    offset: '-0-3:00',
  },
  {
    id: '16a5544c-e669-42c9-95e1-9a0175697459',
    name: 'America/Argentina/Cordoba',
    offset: '-0-3:00',
  },
  {
    id: 'c17681d8-3e04-4109-9f9a-98f445f3fbea',
    name: 'America/Argentina/Jujuy',
    offset: '-0-3:00',
  },
  {
    id: 'fa216e6f-3d30-42ff-84d6-ef4ed0fad70e',
    name: 'America/Argentina/La_Rioja',
    offset: '-0-3:00',
  },
  {
    id: '46222a06-1117-4ffb-a6f6-054798b72e42',
    name: 'America/Argentina/Mendoza',
    offset: '-0-3:00',
  },
  {
    id: '903bc274-29c6-4416-a3c8-aee02c7778bc',
    name: 'America/Argentina/Rio_Gallegos',
    offset: '-0-3:00',
  },
  {
    id: '740d360a-d7c5-4f79-a276-974b01696543',
    name: 'America/Argentina/Salta',
    offset: '-0-3:00',
  },
  {
    id: 'beac1583-0ce2-484e-be56-09a8ea0ffc47',
    name: 'America/Argentina/San_Juan',
    offset: '-0-3:00',
  },
  {
    id: 'c594e46f-79b5-41a6-a1de-d8d1bdd9cc25',
    name: 'America/Argentina/San_Luis',
    offset: '-0-3:00',
  },
  {
    id: '2f26ff0a-abe7-4af1-9d26-dc8444a313ba',
    name: 'America/Argentina/Tucuman',
    offset: '-0-3:00',
  },
  {
    id: '3e4b80d3-47ed-41ca-b7ea-665b4c37d3ab',
    name: 'America/Argentina/Ushuaia',
    offset: '-0-3:00',
  },
  {
    id: 'b3c80c24-dd26-47b3-b102-13cb525b1e79',
    name: 'America/Aruba',
    offset: '-0-4:00',
  },
  {
    id: '356d805c-fccd-41b7-b5df-2ed66a6d5d55',
    name: 'America/Asuncion',
    offset: '-0-3:00',
  },
  {
    id: 'b4523bfe-500c-4c42-81c5-b2e7949df4d1',
    name: 'America/Atikokan',
    offset: '-0-5:00',
  },
  {
    id: 'd611d6b5-828c-4ba0-b5b8-a652b0ebd71a',
    name: 'America/Atka',
    offset: '-0-9:00',
  },
  {
    id: '14e87403-cf54-4753-9d3b-19f03256c302',
    name: 'America/Bahia',
    offset: '-0-3:00',
  },
  {
    id: 'd06da6aa-c26c-42b6-9415-69066fc07811',
    name: 'America/Bahia_Banderas',
    offset: '-0-5:00',
  },
  {
    id: '21b40201-a92c-4cf8-a17d-fc10a255e9af',
    name: 'America/Barbados',
    offset: '-0-4:00',
  },
  {
    id: 'f413b51b-e4f8-44df-983b-72674be32ce7',
    name: 'America/Belem',
    offset: '-0-3:00',
  },
  {
    id: 'd9573357-8c06-4e8f-8648-7c51fafb5d9e',
    name: 'America/Belize',
    offset: '-0-6:00',
  },
  {
    id: 'c0301608-8479-47de-8873-5d1cd38c8eb3',
    name: 'America/Blanc-Sablon',
    offset: '-0-4:00',
  },
  {
    id: 'e4a64b84-9297-4812-8bd0-28cba48910fa',
    name: 'America/Boa_Vista',
    offset: '-0-4:00',
  },
  {
    id: 'b7423f6d-6bc4-4f25-b752-11343c656de3',
    name: 'America/Bogota',
    offset: '-0-5:00',
  },
  {
    id: 'de1d9539-7c28-41e2-aab9-3044925c8839',
    name: 'America/Boise',
    offset: '-0-6:00',
  },
  {
    id: '5e3ef8e4-82b3-4a92-907e-78c3494ebc61',
    name: 'America/Buenos_Aires',
    offset: '-0-3:00',
  },
  {
    id: '1616cc8c-d192-421f-81da-7a4c750dadf2',
    name: 'America/Cambridge_Bay',
    offset: '-0-6:00',
  },
  {
    id: 'fcc202b6-031b-471e-a5b1-facc704a5289',
    name: 'America/Campo_Grande',
    offset: '-0-4:00',
  },
  {
    id: '6a575daf-4235-452b-b486-9e6899d991b0',
    name: 'America/Cancun',
    offset: '-0-5:00',
  },
  {
    id: 'e0993176-d63a-4e12-ad8f-933222221f92',
    name: 'America/Caracas',
    offset: '-0-4:00',
  },
  {
    id: 'ad3a85bc-6a9b-4931-9f4a-6e2af24afd60',
    name: 'America/Catamarca',
    offset: '-0-3:00',
  },
  {
    id: '0d488a7e-c254-4beb-b457-029570792f12',
    name: 'America/Cayenne',
    offset: '-0-3:00',
  },
  {
    id: 'f7f7b967-7e7c-4925-be73-cc737fb236ae',
    name: 'America/Cayman',
    offset: '-0-5:00',
  },
  {
    id: '14af1f5c-eb5b-4268-9313-d101b8a11b87',
    name: 'America/Chicago',
    offset: '-0-5:00',
  },
  {
    id: '42acd0a7-626f-4cad-ae35-a9e8ae1ddeaa',
    name: 'America/Chihuahua',
    offset: '-0-6:00',
  },
  {
    id: '7efc53b9-c8bf-4b28-a20b-0c1a9ced635b',
    name: 'America/Coral_Harbour',
    offset: '-0-5:00',
  },
  {
    id: '902c2aa2-5623-4568-8ac8-b447df87af33',
    name: 'America/Cordoba',
    offset: '-0-3:00',
  },
  {
    id: '12cf56b1-b9b0-4ac0-9e8c-578c06becd3a',
    name: 'America/Costa_Rica',
    offset: '-0-6:00',
  },
  {
    id: '16e74cd0-66e8-4179-bc6a-b192b4615779',
    name: 'America/Creston',
    offset: '-0-7:00',
  },
  {
    id: '284aac8e-48a9-4dfb-aee1-32ffea09477a',
    name: 'America/Cuiaba',
    offset: '-0-4:00',
  },
  {
    id: 'b2077a8e-8414-44da-9b41-56cbdc28d125',
    name: 'America/Curacao',
    offset: '-0-4:00',
  },
  {
    id: 'e4ff3d72-8b2f-40dd-81c6-134b5d1084a8',
    name: 'America/Danmarkshavn',
    offset: '+00:00',
  },
  {
    id: 'c9ded00e-6a6d-4f3a-99ab-72468ac67991',
    name: 'America/Dawson',
    offset: '-0-7:00',
  },
  {
    id: '62e4d3fc-637e-49a1-b3d7-fb35397d0998',
    name: 'America/Dawson_Creek',
    offset: '-0-7:00',
  },
  {
    id: '077895d4-c32a-4c80-a7b9-70336ef3ed37',
    name: 'America/Denver',
    offset: '-0-6:00',
  },
  {
    id: 'bd1de9e1-1bb1-48f7-9850-51b9c17c2e99',
    name: 'America/Detroit',
    offset: '-0-4:00',
  },
  {
    id: '61325076-954c-4488-9544-155507f0d65d',
    name: 'America/Dominica',
    offset: '-0-4:00',
  },
  {
    id: '332f0260-a287-4e79-a0bc-3e5222a1e354',
    name: 'America/Edmonton',
    offset: '-0-6:00',
  },
  {
    id: 'a58012fc-e46f-4c67-ac50-edc1664b61ba',
    name: 'America/Eirunepe',
    offset: '-0-5:00',
  },
  {
    id: 'b16285dc-bfaa-4271-9b53-d4c7fadfe127',
    name: 'America/El_Salvador',
    offset: '-0-6:00',
  },
  {
    id: '7eb726c8-a255-47a3-8da5-5c455be18108',
    name: 'America/Ensenada',
    offset: '-0-7:00',
  },
  {
    id: 'be2e0d1d-d0b3-4291-9b44-1c65d013bde4',
    name: 'America/Fort_Nelson',
    offset: '-0-7:00',
  },
  {
    id: '5a20f366-494b-410f-bd2d-5964d0eb3827',
    name: 'America/Fort_Wayne',
    offset: '-0-4:00',
  },
  {
    id: '1cdec099-440d-4e83-ae90-43ef7c86f7af',
    name: 'America/Fortaleza',
    offset: '-0-3:00',
  },
  {
    id: 'bc4110a1-2144-4dfc-9da3-6ee09b088512',
    name: 'America/Glace_Bay',
    offset: '-0-3:00',
  },
  {
    id: '7129f5a2-4162-4fe3-8b03-df8834fd204f',
    name: 'America/Godthab',
    offset: '-0-2:00',
  },
  {
    id: '012946b0-3357-4a88-9789-2d0948a3b6d9',
    name: 'America/Goose_Bay',
    offset: '-0-3:00',
  },
  {
    id: 'a347b22b-497d-4b1a-ac3c-f6009903d824',
    name: 'America/Grand_Turk',
    offset: '-0-4:00',
  },
  {
    id: '2ac14f9d-8833-463d-a6cb-ad802d2a491a',
    name: 'America/Grenada',
    offset: '-0-4:00',
  },
  {
    id: '82049032-47f6-4b03-876b-fb5d94dff777',
    name: 'America/Guadeloupe',
    offset: '-0-4:00',
  },
  {
    id: '8f75683f-1b50-4b9d-ac0f-e4e47b963dfc',
    name: 'America/Guatemala',
    offset: '-0-6:00',
  },
  {
    id: '091ad090-c40e-43e4-9f70-d56c89846790',
    name: 'America/Guayaquil',
    offset: '-0-5:00',
  },
  {
    id: '80bcaaf8-51a5-4bd3-aa2c-6f52b9fd4fba',
    name: 'America/Guyana',
    offset: '-0-4:00',
  },
  {
    id: 'f005afc0-5f25-43c9-a25f-25d07053cd9f',
    name: 'America/Halifax',
    offset: '-0-3:00',
  },
  {
    id: '08d2d0f2-5022-4d32-9f8d-3fffa2edfc27',
    name: 'America/Havana',
    offset: '-0-4:00',
  },
  {
    id: '419de065-5b3a-49aa-8119-17a18adcba28',
    name: 'America/Hermosillo',
    offset: '-0-7:00',
  },
  {
    id: '8382d2f6-056b-411a-b9c1-373d99f64551',
    name: 'America/Indiana/Indianapolis',
    offset: '-0-4:00',
  },
  {
    id: 'b7e707f2-4ced-46f4-8dba-ec9a96fb57f9',
    name: 'America/Indiana/Knox',
    offset: '-0-5:00',
  },
  {
    id: 'f9c4619c-8b80-4364-91a5-d4eda167bada',
    name: 'America/Indiana/Marengo',
    offset: '-0-4:00',
  },
  {
    id: '77ccd810-5167-4044-a449-e088b0c6e2c4',
    name: 'America/Indiana/Petersburg',
    offset: '-0-4:00',
  },
  {
    id: '26220311-6c20-4b11-b71c-a04934a3d33b',
    name: 'America/Indiana/Tell_City',
    offset: '-0-5:00',
  },
  {
    id: 'a63d7488-3d4b-4bf3-9030-43801770dc48',
    name: 'America/Indiana/Vevay',
    offset: '-0-4:00',
  },
  {
    id: '33a149fc-4da5-45e1-a1fc-5d86d8bee0e6',
    name: 'America/Indiana/Vincennes',
    offset: '-0-4:00',
  },
  {
    id: '163bd2ed-afef-43fc-bb79-e0829a681768',
    name: 'America/Indiana/Winamac',
    offset: '-0-4:00',
  },
  {
    id: '0eeaab53-053c-436b-a4d8-d3eef4162a46',
    name: 'America/Indianapolis',
    offset: '-0-4:00',
  },
  {
    id: '9cc6c267-c7f8-4cb5-8caf-a3772111a8c9',
    name: 'America/Inuvik',
    offset: '-0-6:00',
  },
  {
    id: '061b1a8e-387e-4368-a90f-f30de868b867',
    name: 'America/Iqaluit',
    offset: '-0-4:00',
  },
  {
    id: 'e668663c-c6d0-4bdd-9077-2ceeb5281326',
    name: 'America/Jamaica',
    offset: '-0-5:00',
  },
  {
    id: '59c5f013-52e5-4e09-8981-17c13a0d4461',
    name: 'America/Jujuy',
    offset: '-0-3:00',
  },
  {
    id: '0062ef08-a386-4cc5-a0d6-63f48d177d73',
    name: 'America/Juneau',
    offset: '-0-8:00',
  },
  {
    id: '375777e1-e2f1-4f60-a0bd-11eb627d8c23',
    name: 'America/Kentucky/Louisville',
    offset: '-0-4:00',
  },
  {
    id: 'a74757f5-1094-4c28-83f1-211aea393ce3',
    name: 'America/Kentucky/Monticello',
    offset: '-0-4:00',
  },
  {
    id: 'f6a2c22b-2605-4652-a3ba-ccc0b930b2ec',
    name: 'America/Knox_IN',
    offset: '-0-5:00',
  },
  {
    id: 'eb31c429-659c-40f0-b77b-0bca24776a83',
    name: 'America/Kralendijk',
    offset: '-0-4:00',
  },
  {
    id: '9b1773e2-1e90-48a2-a7bb-ee91b6b6f697',
    name: 'America/La_Paz',
    offset: '-0-4:00',
  },
  {
    id: '6cce70d2-c35e-466e-afb6-300c23fe98a2',
    name: 'America/Lima',
    offset: '-0-5:00',
  },
  {
    id: '0a3fac50-9cc4-4f50-9db3-bc6d26c2777c',
    name: 'America/Los_Angeles',
    offset: '-0-7:00',
  },
  {
    id: '8ceaff86-84ff-46f0-9edc-1a959806a950',
    name: 'America/Louisville',
    offset: '-0-4:00',
  },
  {
    id: '9e716ce0-71c7-4b77-9b55-3f2a63a58771',
    name: 'America/Lower_Princes',
    offset: '-0-4:00',
  },
  {
    id: '5769b53b-5adb-4d4a-a17e-65fda41672de',
    name: 'America/Maceio',
    offset: '-0-3:00',
  },
  {
    id: '41071184-1cb6-4d58-ab8a-f5b6386600c7',
    name: 'America/Managua',
    offset: '-0-6:00',
  },
  {
    id: '50530bd1-2e50-4e28-a9d6-4a3e99fa0527',
    name: 'America/Manaus',
    offset: '-0-4:00',
  },
  {
    id: '3388dbb5-61a7-49e9-a005-c608658947f2',
    name: 'America/Marigot',
    offset: '-0-4:00',
  },
  {
    id: '0d82ac55-9f0b-4f25-a908-3bce85cc6baf',
    name: 'America/Martinique',
    offset: '-0-4:00',
  },
  {
    id: '1cd44e7f-a661-4e26-b925-c8b92e473b60',
    name: 'America/Matamoros',
    offset: '-0-5:00',
  },
  {
    id: '12e20682-c414-4b73-b1f3-c5070aaca898',
    name: 'America/Mazatlan',
    offset: '-0-6:00',
  },
  {
    id: 'f42c1098-1293-4bd9-bc49-4d95e299a5dd',
    name: 'America/Mendoza',
    offset: '-0-3:00',
  },
  {
    id: '822ab973-8cc2-4e5e-8400-bae0d0de83ee',
    name: 'America/Menominee',
    offset: '-0-5:00',
  },
  {
    id: '9bd119f0-5672-4e89-8116-c204d14c6e8c',
    name: 'America/Merida',
    offset: '-0-5:00',
  },
  {
    id: '81592fcf-4a35-4b8f-9535-55db21b409aa',
    name: 'America/Metlakatla',
    offset: '-0-8:00',
  },
  {
    id: '0133e4df-8d4c-4bd9-a994-ecf9a394e6d6',
    name: 'America/Mexico_City',
    offset: '-0-5:00',
  },
  {
    id: 'ac718754-a198-4ec9-8a5f-b322384a7b92',
    name: 'America/Miquelon',
    offset: '-0-2:00',
  },
  {
    id: '6b27acce-7e88-4fe2-9e18-5149d24c9b27',
    name: 'America/Moncton',
    offset: '-0-3:00',
  },
  {
    id: '781a9f53-a63a-4f85-8dbe-da879add8327',
    name: 'America/Monterrey',
    offset: '-0-5:00',
  },
  {
    id: 'faec777a-8ae2-467a-a29f-f29c551c8896',
    name: 'America/Montevideo',
    offset: '-0-3:00',
  },
  {
    id: '91596b92-d6d3-4832-9205-718d4ae8cd74',
    name: 'America/Montreal',
    offset: '-0-4:00',
  },
  {
    id: '0b80fadb-325c-41ab-8119-68f028650cd1',
    name: 'America/Montserrat',
    offset: '-0-4:00',
  },
  {
    id: '9e5db723-e169-4bae-b430-09411b1be09c',
    name: 'America/Nassau',
    offset: '-0-4:00',
  },
  {
    id: '015e28e0-8762-4ffb-8dc7-b7c531643311',
    name: 'America/New_York',
    offset: '-0-4:00',
  },
  {
    id: '39628be9-bded-4533-a9a1-202daac8dbc7',
    name: 'America/Nipigon',
    offset: '-0-4:00',
  },
  {
    id: 'ffad9308-261f-4e7a-afde-3e74b5445c6d',
    name: 'America/Nome',
    offset: '-0-8:00',
  },
  {
    id: 'fea2269b-e89e-4241-bf99-a18d3ea3d755',
    name: 'America/Noronha',
    offset: '-0-2:00',
  },
  {
    id: 'd0ffcf94-3fe6-4681-acac-4e9973e79aab',
    name: 'America/North_Dakota/Beulah',
    offset: '-0-5:00',
  },
  {
    id: '64cdc340-4df1-4930-89a1-089eca0f4d23',
    name: 'America/North_Dakota/Center',
    offset: '-0-5:00',
  },
  {
    id: '5474b980-494b-409a-a233-28ee48455c91',
    name: 'America/North_Dakota/New_Salem',
    offset: '-0-5:00',
  },
  {
    id: '50db19ac-d8ee-4c93-b33b-c52aa302884e',
    name: 'America/Nuuk',
    offset: '-0-2:00',
  },
  {
    id: '6381aee3-35a6-4b6a-915f-99f328fe5d19',
    name: 'America/Ojinaga',
    offset: '-0-6:00',
  },
  {
    id: '4102ce85-f71d-49c0-abd6-0e197d3cbca0',
    name: 'America/Panama',
    offset: '-0-5:00',
  },
  {
    id: 'c0b02b84-497a-4efd-b536-0d857ad6baca',
    name: 'America/Pangnirtung',
    offset: '-0-4:00',
  },
  {
    id: '2c2fa9bb-06f7-4a31-b7b3-6388a779baac',
    name: 'America/Paramaribo',
    offset: '-0-3:00',
  },
  {
    id: '45d51301-b4e7-4615-9813-ecfe0808b515',
    name: 'America/Phoenix',
    offset: '-0-7:00',
  },
  {
    id: '1b351a2d-b5be-4e40-be23-baae35e3e07a',
    name: 'America/Port-au-Prince',
    offset: '-0-4:00',
  },
  {
    id: '14fd8f01-6cd0-429f-a7bb-419188581b25',
    name: 'America/Port_of_Spain',
    offset: '-0-4:00',
  },
  {
    id: 'b1f518b0-485e-4218-8b62-ace7d3a6389a',
    name: 'America/Porto_Acre',
    offset: '-0-5:00',
  },
  {
    id: '2b55bf0b-1731-4eca-be46-0f681146ab16',
    name: 'America/Porto_Velho',
    offset: '-0-4:00',
  },
  {
    id: 'c7cd96a5-0804-4707-91ba-4a1a44d3f038',
    name: 'America/Puerto_Rico',
    offset: '-0-4:00',
  },
  {
    id: '6b645083-d9ed-427f-b4a5-66ded79165a3',
    name: 'America/Punta_Arenas',
    offset: '-0-3:00',
  },
  {
    id: 'da45332e-7204-4639-bfd7-b75089b16cf4',
    name: 'America/Rainy_River',
    offset: '-0-5:00',
  },
  {
    id: '82e82f4b-b528-45d5-abea-4342a2c410aa',
    name: 'America/Rankin_Inlet',
    offset: '-0-5:00',
  },
  {
    id: '25d91e2f-959e-4c38-99c1-fd90e9197255',
    name: 'America/Recife',
    offset: '-0-3:00',
  },
  {
    id: 'b9151952-f6f2-4ec4-8189-308674fd4412',
    name: 'America/Regina',
    offset: '-0-6:00',
  },
  {
    id: '38e0f417-7a00-4c6d-95d3-3dfc0750de1f',
    name: 'America/Resolute',
    offset: '-0-5:00',
  },
  {
    id: '8c56de02-1742-4b6a-b55d-d655e44c464f',
    name: 'America/Rio_Branco',
    offset: '-0-5:00',
  },
  {
    id: '0c36234e-22de-4497-9695-2d3f54ce12cf',
    name: 'America/Rosario',
    offset: '-0-3:00',
  },
  {
    id: '3fafb9de-fed3-42d3-b2b8-c57ab3d19d0a',
    name: 'America/Santa_Isabel',
    offset: '-0-7:00',
  },
  {
    id: 'f5ed8898-e461-45d7-a7d2-585791d08bbc',
    name: 'America/Santarem',
    offset: '-0-3:00',
  },
  {
    id: 'f66a4eb6-8f0a-435f-952b-6c62bb767f2e',
    name: 'America/Santiago',
    offset: '-0-3:00',
  },
  {
    id: 'b4ed7121-7843-4a69-bb1f-59ce7ebe8fea',
    name: 'America/Santo_Domingo',
    offset: '-0-4:00',
  },
  {
    id: 'e894cc0e-1bd1-4186-8647-065424f10175',
    name: 'America/Sao_Paulo',
    offset: '-0-3:00',
  },
  {
    id: '1347ec84-5026-42d6-bc1f-ce6c1a169fef',
    name: 'America/Scoresbysund',
    offset: '+00:00',
  },
  {
    id: 'a9a81b8d-3926-4163-be5c-be9ffaf0103c',
    name: 'America/Shiprock',
    offset: '-0-6:00',
  },
  {
    id: '4328328f-d130-4625-b6e8-4a19692aafc7',
    name: 'America/Sitka',
    offset: '-0-8:00',
  },
  {
    id: 'f52ff6c5-90a9-4c20-9654-7f2b4be3191d',
    name: 'America/St_Barthelemy',
    offset: '-0-4:00',
  },
  {
    id: '06db9744-00fb-4ea8-8f8b-31c4a5ae5757',
    name: 'America/St_Johns',
    offset: '-0-3:30',
  },
  {
    id: '4c358c4f-9892-49dc-a365-b50a6bbea2a1',
    name: 'America/St_Kitts',
    offset: '-0-4:00',
  },
  {
    id: '84fcc457-16ba-4f33-b927-a0163f9da2cb',
    name: 'America/St_Lucia',
    offset: '-0-4:00',
  },
  {
    id: '81cc1f73-7958-495a-924f-1e0fa0666be7',
    name: 'America/St_Thomas',
    offset: '-0-4:00',
  },
  {
    id: 'aee56179-64e0-4958-b875-b50dc77efa21',
    name: 'America/St_Vincent',
    offset: '-0-4:00',
  },
  {
    id: 'b3dbc5d9-a345-4e57-a111-ad873f471cb8',
    name: 'America/Swift_Current',
    offset: '-0-6:00',
  },
  {
    id: 'aa047012-91d8-4155-8d55-84296e30af46',
    name: 'America/Tegucigalpa',
    offset: '-0-6:00',
  },
  {
    id: '1cf3cc8b-e1d1-4e51-80a4-d26abab80cbc',
    name: 'America/Thule',
    offset: '-0-3:00',
  },
  {
    id: 'b2374790-bea6-480d-bf3c-cd9a3d17874d',
    name: 'America/Thunder_Bay',
    offset: '-0-4:00',
  },
  {
    id: '1b55161a-1b66-42f6-8228-872407027e67',
    name: 'America/Tijuana',
    offset: '-0-7:00',
  },
  {
    id: 'cbd33bea-94fa-454b-8633-bfc6460eb6b8',
    name: 'America/Toronto',
    offset: '-0-4:00',
  },
  {
    id: '5018b513-7d8e-41e9-95a1-856b7a74ca9f',
    name: 'America/Tortola',
    offset: '-0-4:00',
  },
  {
    id: '2944e49f-e5a4-479a-a67f-2b361c8f5b33',
    name: 'America/Vancouver',
    offset: '-0-7:00',
  },
  {
    id: 'f406cc7d-79e9-43c2-a3cf-6e96b36d7494',
    name: 'America/Virgin',
    offset: '-0-4:00',
  },
  {
    id: 'ea793c91-edd8-4541-a986-76a4002a591c',
    name: 'America/Whitehorse',
    offset: '-0-7:00',
  },
  {
    id: '80b17c03-6048-4ef7-8498-ff5b5e0bad0f',
    name: 'America/Winnipeg',
    offset: '-0-5:00',
  },
  {
    id: 'a4b5c249-3c67-401b-b273-8b1c109a1d2b',
    name: 'America/Yakutat',
    offset: '-0-8:00',
  },
  {
    id: 'a3902fb6-e23c-44dc-87e6-d32cbef61cb7',
    name: 'America/Yellowknife',
    offset: '-0-6:00',
  },
  {
    id: '5bb17197-a693-472b-bcb4-3b644e63bbac',
    name: 'Antarctica/Casey',
    offset: '+08:00',
  },
  {
    id: 'b9e49cef-861c-400a-825e-abfee69c6f82',
    name: 'Antarctica/Davis',
    offset: '+07:00',
  },
  {
    id: '58a63135-390a-450e-b4c7-8f46831be447',
    name: 'Antarctica/DumontDUrville',
    offset: '+10:00',
  },
  {
    id: '922dbfea-b830-4a22-b8a5-1315edd0be32',
    name: 'Antarctica/Macquarie',
    offset: '+11:00',
  },
  {
    id: '09bfb308-b55c-471d-9bf2-ad5c12c3cd57',
    name: 'Antarctica/Mawson',
    offset: '+05:00',
  },
  {
    id: '2c599af1-f551-4745-8116-3a1ddfea4f13',
    name: 'Antarctica/McMurdo',
    offset: '+13:00',
  },
  {
    id: '63e0ba7c-3160-4b6f-b46b-65f432eab095',
    name: 'Antarctica/Palmer',
    offset: '-0-3:00',
  },
  {
    id: '9c7fb567-d259-40f2-9689-131641fbe2e4',
    name: 'Antarctica/Rothera',
    offset: '-0-3:00',
  },
  {
    id: '3e95898d-c90b-4143-a076-9c0dfc4f5c1d',
    name: 'Antarctica/South_Pole',
    offset: '+13:00',
  },
  {
    id: '57ac02f6-5333-48ab-bf3e-39e7ad00bda0',
    name: 'Antarctica/Syowa',
    offset: '+03:00',
  },
  {
    id: '970f6425-3c96-4f42-b1c0-947de9247ab7',
    name: 'Antarctica/Troll',
    offset: '+02:00',
  },
  {
    id: 'a9e9b293-aaee-4948-bcf7-5b2fc0cf38d7',
    name: 'Antarctica/Vostok',
    offset: '+06:00',
  },
  {
    id: 'e4ceacc7-5e69-4c1d-b447-ec5b1f92a9e4',
    name: 'Arctic/Longyearbyen',
    offset: '+02:00',
  },
  {
    id: '7e7c49fb-f4aa-4d5b-874d-e65736aba52f',
    name: 'Asia/Aden',
    offset: '+03:00',
  },
  {
    id: 'c82bb92e-f7b1-4eed-a735-33684a804340',
    name: 'Asia/Almaty',
    offset: '+06:00',
  },
  {
    id: 'ad8f2e18-da2f-4929-a6d3-6748b348d11e',
    name: 'Asia/Amman',
    offset: '+03:00',
  },
  {
    id: '7743dc66-21f5-479f-a9a6-23f0eade6f5d',
    name: 'Asia/Anadyr',
    offset: '+12:00',
  },
  {
    id: '641f1870-8e18-48c9-a687-bdb843c507a1',
    name: 'Asia/Aqtau',
    offset: '+05:00',
  },
  {
    id: 'c0c4d5ac-424c-4bdc-bed3-69b501a4556b',
    name: 'Asia/Aqtobe',
    offset: '+05:00',
  },
  {
    id: '8d1a06a2-a261-472a-a0a9-b98859b14a2b',
    name: 'Asia/Ashgabat',
    offset: '+05:00',
  },
  {
    id: '6af00586-05b6-49c0-94b3-7b7d2d6ad258',
    name: 'Asia/Ashkhabad',
    offset: '+05:00',
  },
  {
    id: '158e835b-8e39-4dae-a1c6-701ac60cbd51',
    name: 'Asia/Atyrau',
    offset: '+05:00',
  },
  {
    id: 'c791308e-8a8b-433f-9ebd-0bd76f595a69',
    name: 'Asia/Baghdad',
    offset: '+03:00',
  },
  {
    id: '75c35016-be69-456b-a054-0b51f1d2bc38',
    name: 'Asia/Bahrain',
    offset: '+03:00',
  },
  {
    id: 'bd189b40-378f-408e-85a3-7e973558a9eb',
    name: 'Asia/Baku',
    offset: '+04:00',
  },
  {
    id: 'a60b6408-8956-4796-aa63-f1a1540c7fe9',
    name: 'Asia/Bangkok',
    offset: '+07:00',
  },
  {
    id: '68e17ad0-3e7b-4e44-b4dd-f9358c1dddcc',
    name: 'Asia/Barnaul',
    offset: '+07:00',
  },
  {
    id: '88e035b3-8f41-4c7d-b437-ae1a67796dd4',
    name: 'Asia/Beirut',
    offset: '+03:00',
  },
  {
    id: '636d5c7f-4463-4d26-98b0-3b4f3ed0b326',
    name: 'Asia/Bishkek',
    offset: '+06:00',
  },
  {
    id: 'ce27f5d0-92c8-4b9e-bd22-4607663b4f51',
    name: 'Asia/Brunei',
    offset: '+08:00',
  },
  {
    id: 'a679f80c-1fed-4a4e-bdc7-5ab688cd96cc',
    name: 'Asia/Calcutta',
    offset: '+05:30',
  },
  {
    id: 'fa0a71d2-8857-4cd1-98ae-4727382303bd',
    name: 'Asia/Chita',
    offset: '+09:00',
  },
  {
    id: 'e6deb9ef-8659-4d25-a45e-3ed1b688fda1',
    name: 'Asia/Choibalsan',
    offset: '+08:00',
  },
  {
    id: '6b85c2e3-81ba-4324-9ab1-ae2664a0a0b3',
    name: 'Asia/Chongqing',
    offset: '+08:00',
  },
  {
    id: '945c6dab-97df-4d85-98e5-306518172b7b',
    name: 'Asia/Chungking',
    offset: '+08:00',
  },
  {
    id: 'fe9d19d1-c97d-4eee-8df2-c2aae815d1a4',
    name: 'Asia/Colombo',
    offset: '+05:30',
  },
  {
    id: '39c03835-8fdf-4bf5-b5eb-9a598285ebc5',
    name: 'Asia/Dacca',
    offset: '+06:00',
  },
  {
    id: '623fe19a-131e-419e-8b0c-5a3e761e5ae9',
    name: 'Asia/Damascus',
    offset: '+03:00',
  },
  {
    id: '8a1aafd3-f032-464c-af1d-d990bd2f6137',
    name: 'Asia/Dhaka',
    offset: '+06:00',
  },
  {
    id: '35178a53-3d60-442b-a641-909641031935',
    name: 'Asia/Dili',
    offset: '+09:00',
  },
  {
    id: '6ab286df-70e2-4fa7-923d-03309e38e36d',
    name: 'Asia/Dubai',
    offset: '+04:00',
  },
  {
    id: 'ab841768-a997-4fb5-b60d-1e1359c615d0',
    name: 'Asia/Dushanbe',
    offset: '+05:00',
  },
  {
    id: '5601c316-a2c0-4135-a13c-c0ceb8a8221c',
    name: 'Asia/Famagusta',
    offset: '+03:00',
  },
  {
    id: 'f162e692-64a3-4b40-959c-cdbf5c616a70',
    name: 'Asia/Gaza',
    offset: '+03:00',
  },
  {
    id: '74965609-4ecf-4ae5-9492-e36c5a25628d',
    name: 'Asia/Harbin',
    offset: '+08:00',
  },
  {
    id: '2a80d097-b6ce-4857-8760-9b196674348a',
    name: 'Asia/Hebron',
    offset: '+03:00',
  },
  {
    id: '8fdf846b-142b-46a3-a8ba-feb4c12fc746',
    name: 'Asia/Ho_Chi_Minh',
    offset: '+07:00',
  },
  {
    id: '8cd64beb-e115-4a67-baa1-1268b9ae33c2',
    name: 'Asia/Hong_Kong',
    offset: '+08:00',
  },
  {
    id: 'a7ee9d8b-d30a-47a2-96d9-f00431de33a3',
    name: 'Asia/Hovd',
    offset: '+07:00',
  },
  {
    id: 'b0cd2771-3600-43aa-9c6e-78958ea2554c',
    name: 'Asia/Irkutsk',
    offset: '+08:00',
  },
  {
    id: '8a3eaa11-2bfb-46ba-9114-00e5efa3fb6e',
    name: 'Asia/Istanbul',
    offset: '+03:00',
  },
  {
    id: 'a5234ff1-e3c9-414e-99a4-9336622e0023',
    name: 'Asia/Jakarta',
    offset: '+07:00',
  },
  {
    id: 'a585dd94-9175-422c-b2d9-c0a39cc9d78c',
    name: 'Asia/Jayapura',
    offset: '+09:00',
  },
  {
    id: '54b0bd74-b746-4d16-9ae2-eddb25af8685',
    name: 'Asia/Jerusalem',
    offset: '+03:00',
  },
  {
    id: 'cd7269da-15e8-43cc-89e4-7df6e595cb1d',
    name: 'Asia/Kabul',
    offset: '+04:30',
  },
  {
    id: '142a7341-a389-441a-a884-c52dec8005bb',
    name: 'Asia/Kamchatka',
    offset: '+12:00',
  },
  {
    id: 'ec342982-d13e-48e0-81c7-e85dfff889ea',
    name: 'Asia/Karachi',
    offset: '+05:00',
  },
  {
    id: '2ea81d9a-a844-4fa5-82e5-ceb7018722fd',
    name: 'Asia/Kashgar',
    offset: '+06:00',
  },
  {
    id: '68164933-b97d-4b0f-ac96-f8f4606f7d9e',
    name: 'Asia/Kathmandu',
    offset: '+05:45',
  },
  {
    id: '02165cf6-886e-4aba-b8f1-241d12061a8f',
    name: 'Asia/Katmandu',
    offset: '+05:45',
  },
  {
    id: 'a607cc98-d031-477c-b751-8a9dd99d93a6',
    name: 'Asia/Khandyga',
    offset: '+09:00',
  },
  {
    id: '17392371-9b8d-4ece-b2ff-cae9714f55d0',
    name: 'Asia/Kolkata',
    offset: '+05:30',
  },
  {
    id: 'b57d09e9-4c4b-4e0a-9b8b-be51c0b0932a',
    name: 'Asia/Krasnoyarsk',
    offset: '+07:00',
  },
  {
    id: 'ca6b57b8-f20c-44e0-bc5e-db85dea2772f',
    name: 'Asia/Kuala_Lumpur',
    offset: '+08:00',
  },
  {
    id: '09e7a99e-32bd-4b28-b3ba-97c6d6030e87',
    name: 'Asia/Kuching',
    offset: '+08:00',
  },
  {
    id: '078367d1-a040-4e7e-8450-47aa7c3c7a65',
    name: 'Asia/Kuwait',
    offset: '+03:00',
  },
  {
    id: '22b0fd93-5e01-4922-97c0-446ce13e9c9e',
    name: 'Asia/Macao',
    offset: '+08:00',
  },
  {
    id: 'e52b01a7-19f6-4882-ae57-8d0f72b5d209',
    name: 'Asia/Macau',
    offset: '+08:00',
  },
  {
    id: '53115b53-6158-4ea0-8edd-f70a17bb7433',
    name: 'Asia/Magadan',
    offset: '+11:00',
  },
  {
    id: 'b3d52712-8404-4a31-bd95-afecd8c7052c',
    name: 'Asia/Makassar',
    offset: '+08:00',
  },
  {
    id: '7c55e8ba-3027-4bca-a508-7b0641da6f02',
    name: 'Asia/Manila',
    offset: '+08:00',
  },
  {
    id: '588a5df4-c6c1-4715-a3e5-2a17a1a0aae7',
    name: 'Asia/Muscat',
    offset: '+04:00',
  },
  {
    id: '2899cbd9-9dcf-42e0-b208-319c0ea580b3',
    name: 'Asia/Nicosia',
    offset: '+03:00',
  },
  {
    id: 'b79c515f-9229-421c-8c53-dd25bc2be233',
    name: 'Asia/Novokuznetsk',
    offset: '+07:00',
  },
  {
    id: 'cadb206a-2a46-402b-8621-89ebe304faa3',
    name: 'Asia/Novosibirsk',
    offset: '+07:00',
  },
  {
    id: '4d5018ee-6fe4-4245-8f34-365576d60e01',
    name: 'Asia/Omsk',
    offset: '+06:00',
  },
  {
    id: '63d31388-e58d-4b4a-869e-bcd07ace714c',
    name: 'Asia/Oral',
    offset: '+05:00',
  },
  {
    id: '8993737e-fb0b-42af-a4e1-9bffe09cc6dd',
    name: 'Asia/Phnom_Penh',
    offset: '+07:00',
  },
  {
    id: 'af08e930-6825-42e9-bbdd-6688abbedd20',
    name: 'Asia/Pontianak',
    offset: '+07:00',
  },
  {
    id: '563b0118-b8bc-4902-93fa-6da8dff9f268',
    name: 'Asia/Pyongyang',
    offset: '+09:00',
  },
  {
    id: '4b047210-e83b-41f0-82c3-eece9f977732',
    name: 'Asia/Qatar',
    offset: '+03:00',
  },
  {
    id: 'd126af0c-a494-4789-b5bb-6832ac194b90',
    name: 'Asia/Qostanay',
    offset: '+06:00',
  },
  {
    id: '92e17705-35b8-4ec2-9529-f87a3978e8b4',
    name: 'Asia/Qyzylorda',
    offset: '+05:00',
  },
  {
    id: '657bdc92-23ad-4f36-b827-f1c6d1a06dfc',
    name: 'Asia/Rangoon',
    offset: '+06:30',
  },
  {
    id: '7c0d2308-397a-4943-87ae-213b1bd2513e',
    name: 'Asia/Riyadh',
    offset: '+03:00',
  },
  {
    id: '5e4ee3f9-e1ff-4f1c-af1f-358009712223',
    name: 'Asia/Saigon',
    offset: '+07:00',
  },
  {
    id: '35f53d18-a2dd-4acf-80b9-7830c56abc9f',
    name: 'Asia/Sakhalin',
    offset: '+11:00',
  },
  {
    id: '7dd961d1-91db-4c19-83b2-bd070ed6e5c9',
    name: 'Asia/Samarkand',
    offset: '+05:00',
  },
  {
    id: '133959ec-d23f-4833-8be3-f7f1c6475ef9',
    name: 'Asia/Seoul',
    offset: '+09:00',
  },
  {
    id: 'e5d70a58-d80f-4810-ae8a-c9129ddc5915',
    name: 'Asia/Shanghai',
    offset: '+08:00',
  },
  {
    id: '3325d1a9-6f84-4a30-a494-91e7c0889792',
    name: 'Asia/Singapore',
    offset: '+08:00',
  },
  {
    id: '459626a4-aff6-4090-a3bc-a437f5474963',
    name: 'Asia/Srednekolymsk',
    offset: '+11:00',
  },
  {
    id: 'bc300567-984a-4405-8958-f079a2abf795',
    name: 'Asia/Taipei',
    offset: '+08:00',
  },
  {
    id: '200005f0-3af5-4a06-9baa-fc1f70cb2c3d',
    name: 'Asia/Tashkent',
    offset: '+05:00',
  },
  {
    id: 'e4ab3efb-d250-4cd3-8789-44df4148f041',
    name: 'Asia/Tbilisi',
    offset: '+04:00',
  },
  {
    id: 'a4fd024d-6fcf-4b1d-b4d1-7f9bdf3162fb',
    name: 'Asia/Tehran',
    offset: '+03:30',
  },
  {
    id: '402b1ca3-44e5-464d-86a7-5b554d2d9e3b',
    name: 'Asia/Tel_Aviv',
    offset: '+03:00',
  },
  {
    id: '71a25de9-7b90-4492-8f0c-62840ee40bca',
    name: 'Asia/Thimbu',
    offset: '+06:00',
  },
  {
    id: 'b76ac66a-fb87-427a-9be3-5d9425f67a47',
    name: 'Asia/Thimphu',
    offset: '+06:00',
  },
  {
    id: '94fa3610-5a25-4f90-ae4f-b466e8d23893',
    name: 'Asia/Tokyo',
    offset: '+09:00',
  },
  {
    id: 'ed89ea52-26fb-483e-b715-48588372bc62',
    name: 'Asia/Tomsk',
    offset: '+07:00',
  },
  {
    id: '73703a91-73e6-4125-a0a2-aa66496fe0f8',
    name: 'Asia/Ujung_Pandang',
    offset: '+08:00',
  },
  {
    id: '283286a8-a8d3-435e-8c75-564f116b900b',
    name: 'Asia/Ulaanbaatar',
    offset: '+08:00',
  },
  {
    id: '4702b2c2-c7ac-4458-aed9-2582cdf0956e',
    name: 'Asia/Ulan_Bator',
    offset: '+08:00',
  },
  {
    id: '1f931ac4-b96b-401e-9aff-8bdc8f7d70d1',
    name: 'Asia/Urumqi',
    offset: '+06:00',
  },
  {
    id: 'b8507d9b-f761-4534-a80b-3b1061c0d574',
    name: 'Asia/Ust-Nera',
    offset: '+10:00',
  },
  {
    id: 'e25c8198-41a0-4ee1-9947-eef467c10932',
    name: 'Asia/Vientiane',
    offset: '+07:00',
  },
  {
    id: 'e3763d82-2650-4703-86a2-965ebd8b2167',
    name: 'Asia/Vladivostok',
    offset: '+10:00',
  },
  {
    id: 'ebf61133-4cb7-4815-ac85-6b4332bd5a4f',
    name: 'Asia/Yakutsk',
    offset: '+09:00',
  },
  {
    id: '4afd2f48-c761-46c6-a041-c65fac74133c',
    name: 'Asia/Yangon',
    offset: '+06:30',
  },
  {
    id: 'f62d5b61-1707-4703-ad29-69efd1ab42d2',
    name: 'Asia/Yekaterinburg',
    offset: '+05:00',
  },
  {
    id: '2aa49530-f07e-43b2-a049-5a51088aeeaf',
    name: 'Asia/Yerevan',
    offset: '+04:00',
  },
  {
    id: '725d7f4b-fd92-4e53-9274-0ac0924d6179',
    name: 'Atlantic/Azores',
    offset: '+00:00',
  },
  {
    id: '9014e3cd-ba7a-447d-959d-08dfc77d74f6',
    name: 'Atlantic/Bermuda',
    offset: '-0-3:00',
  },
  {
    id: '9a118878-b94c-4567-94a2-7f13a6561407',
    name: 'Atlantic/Canary',
    offset: '+01:00',
  },
  {
    id: '2aa70fd0-2b6e-400a-b400-b97f6c96451f',
    name: 'Atlantic/Cape_Verde',
    offset: '-0-1:00',
  },
  {
    id: '28e5aa92-d49c-4ea9-9960-512c35ccb176',
    name: 'Atlantic/Faeroe',
    offset: '+01:00',
  },
  {
    id: '7a012bdd-50ef-46e4-a03c-52d291c7d69c',
    name: 'Atlantic/Faroe',
    offset: '+01:00',
  },
  {
    id: '18511de8-93c2-4edb-8741-c8fdd89def10',
    name: 'Atlantic/Jan_Mayen',
    offset: '+02:00',
  },
  {
    id: '0ee4f740-344e-46e4-b972-241097e00c63',
    name: 'Atlantic/Madeira',
    offset: '+01:00',
  },
  {
    id: '9c3fca6b-887b-40fa-83e3-8192bef5c1e5',
    name: 'Atlantic/Reykjavik',
    offset: '+00:00',
  },
  {
    id: '042fb62f-cd4a-4cfb-86b8-128aeb1e9369',
    name: 'Atlantic/South_Georgia',
    offset: '-0-2:00',
  },
  {
    id: 'f98d7144-f0c2-44ec-a83b-c62df886be64',
    name: 'Atlantic/St_Helena',
    offset: '+00:00',
  },
  {
    id: '6cb5b243-6753-492c-bd82-9951b0492b63',
    name: 'Atlantic/Stanley',
    offset: '-0-3:00',
  },
  {
    id: '86c0a163-48db-4373-adf9-0279c72fb7ae',
    name: 'Australia/ACT',
    offset: '+11:00',
  },
  {
    id: '112fa2dd-32af-47fe-b307-ba871248691a',
    name: 'Australia/Adelaide',
    offset: '+10:30',
  },
  {
    id: '8255031d-1e1f-4487-80c3-65f3ad4e5793',
    name: 'Australia/Brisbane',
    offset: '+10:00',
  },
  {
    id: '40cdc14f-74bc-4ba9-aa05-8fe6f850b342',
    name: 'Australia/Broken_Hill',
    offset: '+10:30',
  },
  {
    id: 'f449866d-3ca1-4e60-b6f3-7f5436232c0d',
    name: 'Australia/Canberra',
    offset: '+11:00',
  },
  {
    id: '7d14ff2c-b6e1-4a61-9db6-c159a400bc32',
    name: 'Australia/Currie',
    offset: '+11:00',
  },
  {
    id: '88781542-658e-4be6-afb9-1bd01c8a260b',
    name: 'Australia/Darwin',
    offset: '+09:30',
  },
  {
    id: 'a0160dc1-47de-4251-b489-7a935c08db1f',
    name: 'Australia/Eucla',
    offset: '+08:45',
  },
  {
    id: 'd3326eef-76ef-46c0-9795-e12dad86778f',
    name: 'Australia/Hobart',
    offset: '+11:00',
  },
  {
    id: 'e81130a6-dd84-477a-8e77-bb689b1c381d',
    name: 'Australia/LHI',
    offset: '+11:00',
  },
  {
    id: '10e0fbd4-a35f-4213-8622-8976aab87bb7',
    name: 'Australia/Lindeman',
    offset: '+10:00',
  },
  {
    id: '6043d462-e949-48c0-9a4d-4fe1a5ee9990',
    name: 'Australia/Lord_Howe',
    offset: '+11:00',
  },
  {
    id: '38f122a6-731a-4065-b5d1-9139e11a26bb',
    name: 'Australia/Melbourne',
    offset: '+11:00',
  },
  {
    id: '145dc853-00f9-4a7c-849a-92753f2edae6',
    name: 'Australia/NSW',
    offset: '+11:00',
  },
  {
    id: 'd9e41f3f-a5c7-4015-a59f-b09999e09cf5',
    name: 'Australia/North',
    offset: '+09:30',
  },
  {
    id: '8bdc07b3-c6c4-413b-a91f-e5b2da205c19',
    name: 'Australia/Perth',
    offset: '+08:00',
  },
  {
    id: '20abe4c6-f36e-45e3-83e7-c33f6aeebb8d',
    name: 'Australia/Queensland',
    offset: '+10:00',
  },
  {
    id: '57b9d49c-b2fe-48cf-8650-b81952f90d50',
    name: 'Australia/South',
    offset: '+10:30',
  },
  {
    id: '283d3215-3a0a-4c80-87ee-8a2586ed6850',
    name: 'Australia/Sydney',
    offset: '+11:00',
  },
  {
    id: '968bbbbf-fcbe-462d-b6f1-014209ee05f7',
    name: 'Australia/Tasmania',
    offset: '+11:00',
  },
  {
    id: '7efe08f1-f55d-42d2-a126-b73a5abe1803',
    name: 'Australia/Victoria',
    offset: '+11:00',
  },
  {
    id: 'a8d942c7-8a0f-4a70-a389-4c45105822e5',
    name: 'Australia/West',
    offset: '+08:00',
  },
  {
    id: 'b9d3c0ec-78ee-4c5d-9559-7509b42a28f3',
    name: 'Australia/Yancowinna',
    offset: '+10:30',
  },
  {
    id: 'a7a18678-6760-4aa8-b461-8503270ec5d7',
    name: 'Brazil/Acre',
    offset: '-0-5:00',
  },
  {
    id: 'aed3b2c0-4d9d-4a52-a686-c9b43530a4e5',
    name: 'Brazil/DeNoronha',
    offset: '-0-2:00',
  },
  {
    id: '9faa6262-9a8d-4ec3-bb1b-b092481e0e55',
    name: 'Brazil/East',
    offset: '-0-3:00',
  },
  {
    id: '3fce7e69-bdc4-46fc-bd7b-b2fc1f7381cb',
    name: 'Brazil/West',
    offset: '-0-4:00',
  },
  {
    id: 'f480b2b1-0394-44b3-9331-d594e3b94161',
    name: 'CET',
    offset: '+02:00',
  },
  {
    id: 'c1e104fb-d40e-42b7-9d06-b8cc835c3857',
    name: 'CST6CDT',
    offset: '-0-5:00',
  },
  {
    id: '57c73d67-f1be-42e8-abee-652ed254e257',
    name: 'Canada/Atlantic',
    offset: '-0-3:00',
  },
  {
    id: '779538a3-5247-487d-a347-615791fb0935',
    name: 'Canada/Central',
    offset: '-0-5:00',
  },
  {
    id: '91eef532-6f17-4540-beda-4e1c6141fd3f',
    name: 'Canada/Eastern',
    offset: '-0-4:00',
  },
  {
    id: 'af088d87-bc47-4fee-a406-02fd0ece10ea',
    name: 'Canada/Mountain',
    offset: '-0-6:00',
  },
  {
    id: 'f1bece2d-dc15-4adf-af87-ec7141ba106a',
    name: 'Canada/Newfoundland',
    offset: '-0-3:30',
  },
  {
    id: '7ea2ea0e-0570-40b1-b624-41a80423caae',
    name: 'Canada/Pacific',
    offset: '-0-7:00',
  },
  {
    id: 'c8435f42-b0e5-424c-a6bf-2c572a526dbc',
    name: 'Canada/Saskatchewan',
    offset: '-0-6:00',
  },
  {
    id: 'd2cd2bff-5594-4c76-bc85-9ac155100395',
    name: 'Canada/Yukon',
    offset: '-0-7:00',
  },
  {
    id: '42c18753-7226-4624-855b-cfc5345c2575',
    name: 'Chile/Continental',
    offset: '-0-3:00',
  },
  {
    id: '92bd9937-0c0d-4a76-a6e9-20f5648badfb',
    name: 'Chile/EasterIsland',
    offset: '-0-5:00',
  },
  {
    id: 'f1739196-4fc7-4ab3-a5a5-3354d7108b65',
    name: 'Cuba',
    offset: '-0-4:00',
  },
  {
    id: '2448df77-d4c5-4e94-83ef-e2ad9af269de',
    name: 'EET',
    offset: '+03:00',
  },
  {
    id: 'f19985f7-0d2c-4483-a10b-dcacd81a2f27',
    name: 'EST',
    offset: '-0-5:00',
  },
  {
    id: 'e89c7235-1b30-420b-b500-1b4a2f81630a',
    name: 'EST5EDT',
    offset: '-0-4:00',
  },
  {
    id: 'a51e9739-b069-4f13-b6e6-306092d36261',
    name: 'Egypt',
    offset: '+02:00',
  },
  {
    id: '88c9c6c8-6443-452f-adcc-cd6dc8d3dbed',
    name: 'Eire',
    offset: '+01:00',
  },
  {
    id: '302fc492-0d91-4b89-847b-46a5a0eac40c',
    name: 'Etc/GMT',
    offset: '+00:00',
  },
  {
    id: 'ef8e370a-a895-4fe0-8fc6-489893b41f5f',
    name: 'Etc/GMT+0',
    offset: '+00:00',
  },
  {
    id: 'bbb25490-9bc3-4a1a-8f12-334bcb226db6',
    name: 'Etc/GMT+1',
    offset: '-0-1:00',
  },
  {
    id: '71d9248e-9c13-4c39-a53d-1a8178b4d4d4',
    name: 'Etc/GMT+10',
    offset: '-0-10:00',
  },
  {
    id: '59b5156f-8b55-4433-844e-2e7f43acc4e0',
    name: 'Etc/GMT+11',
    offset: '-0-11:00',
  },
  {
    id: '54aeae1c-57f3-4d70-b01d-c70f0551a198',
    name: 'Etc/GMT+12',
    offset: '-0-12:00',
  },
  {
    id: 'b95e8b7e-6df5-473f-aa2b-157bd7be4bd1',
    name: 'Etc/GMT+2',
    offset: '-0-2:00',
  },
  {
    id: '648871a7-9d35-4576-9729-611bb670aa55',
    name: 'Etc/GMT+3',
    offset: '-0-3:00',
  },
  {
    id: 'bca8fdce-8103-4fd1-8e8f-599e514c79c6',
    name: 'Etc/GMT+4',
    offset: '-0-4:00',
  },
  {
    id: '26fcfbf8-a086-44a4-8f04-774f020ace3c',
    name: 'Etc/GMT+5',
    offset: '-0-5:00',
  },
  {
    id: '94d1de91-0612-4ca1-9e54-1af1e7e05578',
    name: 'Etc/GMT+6',
    offset: '-0-6:00',
  },
  {
    id: 'c432c060-6d80-4afe-a9cc-562f2daea619',
    name: 'Etc/GMT+7',
    offset: '-0-7:00',
  },
  {
    id: '6b51302c-c2c5-4be9-8c57-ca765b938029',
    name: 'Etc/GMT+8',
    offset: '-0-8:00',
  },
  {
    id: 'a715892b-55d3-4a9a-8450-aeb4f1de32ae',
    name: 'Etc/GMT+9',
    offset: '-0-9:00',
  },
  {
    id: '10949550-e272-45bb-afb6-c68adc42bf90',
    name: 'Etc/GMT-0',
    offset: '+00:00',
  },
  {
    id: '1f971dfe-d974-4b64-a926-445182ea2097',
    name: 'Etc/GMT-1',
    offset: '+01:00',
  },
  {
    id: '0adc7e14-5078-4425-9167-39e64c5811d3',
    name: 'Etc/GMT-10',
    offset: '+10:00',
  },
  {
    id: '8fdba74a-8485-4243-a4ba-6d063fe2ea34',
    name: 'Etc/GMT-11',
    offset: '+11:00',
  },
  {
    id: '4c186ba7-eef9-4986-9020-6c7cf1f7009b',
    name: 'Etc/GMT-12',
    offset: '+12:00',
  },
  {
    id: '2cba50e7-7c29-4477-b145-8fc8e29e4f22',
    name: 'Etc/GMT-13',
    offset: '+13:00',
  },
  {
    id: 'c40075c8-e63c-4e38-b322-a6d9062ab0db',
    name: 'Etc/GMT-14',
    offset: '+14:00',
  },
  {
    id: '2246551d-2f83-4845-b253-a18f0d90cdb9',
    name: 'Etc/GMT-2',
    offset: '+02:00',
  },
  {
    id: 'c3dfabdb-54b6-4a14-924c-ad2159216a55',
    name: 'Etc/GMT-3',
    offset: '+03:00',
  },
  {
    id: 'ba2df5ab-c6fc-411d-a728-96977d585db0',
    name: 'Etc/GMT-4',
    offset: '+04:00',
  },
  {
    id: '2d937cda-9c43-43b6-a132-9fa9dd3a9619',
    name: 'Etc/GMT-5',
    offset: '+05:00',
  },
  {
    id: '6cfc155d-349c-475c-82d8-043bacb47286',
    name: 'Etc/GMT-6',
    offset: '+06:00',
  },
  {
    id: '34611fc4-e7c7-4e5b-831c-51b736b8eb0b',
    name: 'Etc/GMT-7',
    offset: '+07:00',
  },
  {
    id: '4941e6fc-6a43-4cb3-8d8c-6a33113a1031',
    name: 'Etc/GMT-8',
    offset: '+08:00',
  },
  {
    id: 'f5e0cf27-c552-438e-9a95-ec71bbdc38d5',
    name: 'Etc/GMT-9',
    offset: '+09:00',
  },
  {
    id: '5a165d2c-a44b-4bb2-aa59-9ad02b52135a',
    name: 'Etc/GMT0',
    offset: '+00:00',
  },
  {
    id: '29142bfd-123f-400f-becd-4ded8b2640fd',
    name: 'Etc/Greenwich',
    offset: '+00:00',
  },
  {
    id: '9034040d-8ca4-4203-bcdd-bd571ba465a9',
    name: 'Etc/UCT',
    offset: '+00:00',
  },
  {
    id: '774f986d-c0e8-406a-bb25-97104bd724fa',
    name: 'Etc/UTC',
    offset: '+00:00',
  },
  {
    id: 'fa468a61-e4db-4657-a99b-6e2538dedd13',
    name: 'Etc/Universal',
    offset: '+00:00',
  },
  {
    id: '543d11c7-1fe1-40fc-bd21-280e8f10fd83',
    name: 'Etc/Zulu',
    offset: '+00:00',
  },
  {
    id: 'a0fa7a84-a576-4e10-8e39-407b64354560',
    name: 'Europe/Amsterdam',
    offset: '+02:00',
  },
  {
    id: '06e79b60-a93f-46e2-a9f1-d7543e2e9202',
    name: 'Europe/Andorra',
    offset: '+02:00',
  },
  {
    id: 'fed9859e-f3cf-40cf-a2fa-29691477f73e',
    name: 'Europe/Astrakhan',
    offset: '+04:00',
  },
  {
    id: 'a8d24d08-2cf6-4392-b15e-6cd863b442d4',
    name: 'Europe/Athens',
    offset: '+03:00',
  },
  {
    id: 'd22540df-8a52-4e0b-ab5b-ec2edd28b3f2',
    name: 'Europe/Belfast',
    offset: '+01:00',
  },
  {
    id: '59ee7659-bf16-468e-b145-a6514f341f9e',
    name: 'Europe/Belgrade',
    offset: '+02:00',
  },
  {
    id: 'c07a2e36-1b7d-4d49-b1bb-a0d69b0d6642',
    name: 'Europe/Berlin',
    offset: '+02:00',
  },
  {
    id: '3ecca9ea-d784-4d35-bb7e-6977de26d295',
    name: 'Europe/Bratislava',
    offset: '+02:00',
  },
  {
    id: 'ba475451-c466-4f8e-9706-0fb9d31b20d3',
    name: 'Europe/Brussels',
    offset: '+02:00',
  },
  {
    id: '5dbee9c0-ff30-4e1b-8896-d1911b804d76',
    name: 'Europe/Bucharest',
    offset: '+03:00',
  },
  {
    id: '010d637e-d438-4787-bc58-636d60280f46',
    name: 'Europe/Budapest',
    offset: '+02:00',
  },
  {
    id: '96c748d0-47ec-4b22-8b27-f416e310eedc',
    name: 'Europe/Busingen',
    offset: '+02:00',
  },
  {
    id: 'b0eacaf0-dabd-4933-bd2a-462cab6e9da7',
    name: 'Europe/Chisinau',
    offset: '+03:00',
  },
  {
    id: 'b8eb8104-c4e0-49b0-83c8-2f75e4f7c847',
    name: 'Europe/Copenhagen',
    offset: '+02:00',
  },
  {
    id: '720af58a-027a-45a5-8e3e-a8d815dcedb7',
    name: 'Europe/Dublin',
    offset: '+01:00',
  },
  {
    id: 'da087f84-7a1f-49e1-8bc6-25de2dcfb47e',
    name: 'Europe/Gibraltar',
    offset: '+02:00',
  },
  {
    id: '5c7f682b-c192-4394-8185-db16687889d7',
    name: 'Europe/Guernsey',
    offset: '+01:00',
  },
  {
    id: '77aee33d-cf63-4d8d-92dc-63b4a0d4eb35',
    name: 'Europe/Helsinki',
    offset: '+03:00',
  },
  {
    id: 'aee47208-c709-4b9c-bf5a-96a2da35fa1d',
    name: 'Europe/Isle_of_Man',
    offset: '+01:00',
  },
  {
    id: '9f657f8c-74a0-4eba-a702-74a8368516d6',
    name: 'Europe/Istanbul',
    offset: '+03:00',
  },
  {
    id: '3ac06cc1-13bf-468b-a6db-7ddd8c8b0eac',
    name: 'Europe/Jersey',
    offset: '+01:00',
  },
  {
    id: '5107fd13-ccae-4a8f-be52-c9cb650fc807',
    name: 'Europe/Kaliningrad',
    offset: '+02:00',
  },
  {
    id: '03501fc8-6657-41b4-a122-30d21de95f20',
    name: 'Europe/Kiev',
    offset: '+03:00',
  },
  {
    id: '9af68885-2805-4435-8509-1e3aa239ed73',
    name: 'Europe/Kirov',
    offset: '+03:00',
  },
  {
    id: 'd3d98464-bbbe-4cac-ac27-b81b721c653b',
    name: 'Europe/Lisbon',
    offset: '+01:00',
  },
  {
    id: 'ff6c795d-a3ea-4762-ae7c-806ce59dd782',
    name: 'Europe/Ljubljana',
    offset: '+02:00',
  },
  {
    id: 'd0c335b0-cc04-46e6-b1f7-361f83965b79',
    name: 'Europe/London',
    offset: '+01:00',
  },
  {
    id: 'd153a0ed-aa64-450e-b5a8-27d67bffc6e8',
    name: 'Europe/Luxembourg',
    offset: '+02:00',
  },
  {
    id: '4ee735a5-0fbe-4c48-907c-95c73a646db1',
    name: 'Europe/Madrid',
    offset: '+02:00',
  },
  {
    id: '2f634532-a850-4894-92cc-3904daf5def5',
    name: 'Europe/Malta',
    offset: '+02:00',
  },
  {
    id: '1f58f29d-c51c-4b85-8222-ae5d8fdfe167',
    name: 'Europe/Mariehamn',
    offset: '+03:00',
  },
  {
    id: '406a51f4-9cc2-42b8-a106-9cc2770c47d3',
    name: 'Europe/Minsk',
    offset: '+03:00',
  },
  {
    id: 'd97159fa-6b12-49cf-8731-293488c8471e',
    name: 'Europe/Monaco',
    offset: '+02:00',
  },
  {
    id: 'b461b265-f510-41d3-885a-aec9b923b29e',
    name: 'Europe/Moscow',
    offset: '+03:00',
  },
  {
    id: '58ec485b-43d0-41f4-904e-ea150b893fc5',
    name: 'Europe/Nicosia',
    offset: '+03:00',
  },
  {
    id: 'e4bdb243-f766-4db3-84bb-c9e61de650ba',
    name: 'Europe/Oslo',
    offset: '+02:00',
  },
  {
    id: '9e10933d-d856-4a66-8242-8e5cae3452ee',
    name: 'Europe/Paris',
    offset: '+02:00',
  },
  {
    id: 'a6b5728f-6984-4218-aa10-7d52aba04b3e',
    name: 'Europe/Podgorica',
    offset: '+02:00',
  },
  {
    id: 'f6e91d89-c592-4929-bb73-284edb944be6',
    name: 'Europe/Prague',
    offset: '+02:00',
  },
  {
    id: '6d06bc2f-bdbd-4b33-bca0-2a2a8a71cad4',
    name: 'Europe/Riga',
    offset: '+03:00',
  },
  {
    id: 'de3f1489-7a87-4b88-b7b5-2c5fc5a83d32',
    name: 'Europe/Rome',
    offset: '+02:00',
  },
  {
    id: '44c1f1eb-a5a2-44c7-9713-e230e00a209e',
    name: 'Europe/Samara',
    offset: '+04:00',
  },
  {
    id: 'af061f01-6306-4016-9ffa-3cb721dd9a9c',
    name: 'Europe/San_Marino',
    offset: '+02:00',
  },
  {
    id: 'c2297e8b-bcf9-4a9b-a998-43637dde471a',
    name: 'Europe/Sarajevo',
    offset: '+02:00',
  },
  {
    id: '06ef17d9-659d-47c4-9362-85107e68e9e4',
    name: 'Europe/Saratov',
    offset: '+04:00',
  },
  {
    id: 'a719e35d-c26c-4d5e-b7e5-ff5314e4ad90',
    name: 'Europe/Simferopol',
    offset: '+03:00',
  },
  {
    id: 'c28325d9-6277-464a-85cf-4fe2f4071ff1',
    name: 'Europe/Skopje',
    offset: '+02:00',
  },
  {
    id: '33a06042-aeb1-44ad-847b-56c587bec8a1',
    name: 'Europe/Sofia',
    offset: '+03:00',
  },
  {
    id: '7bb464f8-32a0-4cea-a440-0f6c074a070f',
    name: 'Europe/Stockholm',
    offset: '+02:00',
  },
  {
    id: '2ff3e1d6-7f41-4cbb-ada6-a5abff28cdb5',
    name: 'Europe/Tallinn',
    offset: '+03:00',
  },
  {
    id: 'ce513fcb-6762-4262-8571-a29b22894524',
    name: 'Europe/Tirane',
    offset: '+02:00',
  },
  {
    id: 'd203420f-25e4-46b1-8921-b0e392f01a7e',
    name: 'Europe/Tiraspol',
    offset: '+03:00',
  },
  {
    id: 'b99b8e5c-7333-41e9-ac20-eaf64b29d6a3',
    name: 'Europe/Ulyanovsk',
    offset: '+04:00',
  },
  {
    id: 'fb3d181b-7e53-44d1-a996-557e19fe31d8',
    name: 'Europe/Uzhgorod',
    offset: '+03:00',
  },
  {
    id: 'b926312e-ae58-4570-bff9-de18de85ac1b',
    name: 'Europe/Vaduz',
    offset: '+02:00',
  },
  {
    id: 'b94b635e-0092-4f41-9e94-c3205cd96054',
    name: 'Europe/Vatican',
    offset: '+02:00',
  },
  {
    id: 'da1f8125-34cf-4630-8393-8e0dca8a47ef',
    name: 'Europe/Vienna',
    offset: '+02:00',
  },
  {
    id: '1e0e28d1-a3e5-408e-8f05-11e0f3dff576',
    name: 'Europe/Vilnius',
    offset: '+03:00',
  },
  {
    id: 'e74faa19-756c-435c-a378-aaa4741da695',
    name: 'Europe/Volgograd',
    offset: '+04:00',
  },
  {
    id: 'b13afced-254a-47f9-860a-e54ff437f231',
    name: 'Europe/Warsaw',
    offset: '+02:00',
  },
  {
    id: '4f4fef65-4b94-42d3-a9ae-e546a2b0fabb',
    name: 'Europe/Zagreb',
    offset: '+02:00',
  },
  {
    id: '075312ec-6a56-4c63-8f74-e44ed918d4dc',
    name: 'Europe/Zaporozhye',
    offset: '+03:00',
  },
  {
    id: 'd096dee9-354c-4791-94b2-c98fd5cf868f',
    name: 'Europe/Zurich',
    offset: '+02:00',
  },
  {
    id: '2aee63d3-ba21-4e5b-b684-5fcc67341baf',
    name: 'GB',
    offset: '+01:00',
  },
  {
    id: 'd13d28d9-1db3-4e50-8e7e-e0da00630c08',
    name: 'GB-Eire',
    offset: '+01:00',
  },
  {
    id: '68b24046-d79d-4f55-9147-4311bee5c857',
    name: 'GMT',
    offset: '+00:00',
  },
  {
    id: 'f7db6ca0-c2ed-4a54-9fac-2e9c1b9af8c6',
    name: 'GMT+0',
    offset: '+00:00',
  },
  {
    id: 'c88f1210-7890-4c6e-99e2-1fb41a7cbf95',
    name: 'GMT-0',
    offset: '+00:00',
  },
  {
    id: 'adaa9a1c-a4a3-4911-8ca2-ebca37f11304',
    name: 'GMT0',
    offset: '+00:00',
  },
  {
    id: '09c2a79f-43ff-445e-84d9-0d7cc858ac84',
    name: 'Greenwich',
    offset: '+00:00',
  },
  {
    id: '4c97d6d5-41c0-4542-b162-3cb478069c1c',
    name: 'HST',
    offset: '-0-10:00',
  },
  {
    id: 'ef9a963b-99b6-4e86-bcd9-c856b0dc282c',
    name: 'Hongkong',
    offset: '+08:00',
  },
  {
    id: '8c1f4870-71bd-4aec-b94f-6327cfbd06a5',
    name: 'Iceland',
    offset: '+00:00',
  },
  {
    id: '52501653-0493-4ee8-b2d1-297bd74eaaa2',
    name: 'Indian/Antananarivo',
    offset: '+03:00',
  },
  {
    id: '71bb753d-8620-4c1a-92d1-68ac95cfa4f0',
    name: 'Indian/Chagos',
    offset: '+06:00',
  },
  {
    id: '3e478b84-603f-4fd5-b9e3-621ee53c64fc',
    name: 'Indian/Christmas',
    offset: '+07:00',
  },
  {
    id: 'd82e56cb-344d-47bf-a722-e3987be53dd7',
    name: 'Indian/Cocos',
    offset: '+06:30',
  },
  {
    id: 'c4ff0222-6dfd-4b4e-875c-2bbba88013c2',
    name: 'Indian/Comoro',
    offset: '+03:00',
  },
  {
    id: '4f94a2b1-5e3c-45e1-b5b0-d8fb21b952ac',
    name: 'Indian/Kerguelen',
    offset: '+05:00',
  },
  {
    id: '07ee7532-63af-4e89-bb82-14f3291c92a2',
    name: 'Indian/Mahe',
    offset: '+04:00',
  },
  {
    id: '0063905a-8798-4593-ae2f-1109204aa80c',
    name: 'Indian/Maldives',
    offset: '+05:00',
  },
  {
    id: '9d54d930-a7ed-4676-a506-a1f8f34bdd6c',
    name: 'Indian/Mauritius',
    offset: '+04:00',
  },
  {
    id: '8228b6b6-559c-4edf-925e-4d3490ef73ee',
    name: 'Indian/Mayotte',
    offset: '+03:00',
  },
  {
    id: '6b4a9bff-a435-4e88-8552-f451dad1bc72',
    name: 'Indian/Reunion',
    offset: '+04:00',
  },
  {
    id: '1f1c4d0a-3689-4ff5-9622-2cb2f8d22352',
    name: 'Iran',
    offset: '+03:30',
  },
  {
    id: '169f2371-254f-4105-a100-d2082bfd94ea',
    name: 'Israel',
    offset: '+03:00',
  },
  {
    id: '028f6836-7e3d-4622-b023-0b4357caf12c',
    name: 'Jamaica',
    offset: '-0-5:00',
  },
  {
    id: 'f07bd34f-9894-4e29-9512-ef8614ea77fd',
    name: 'Japan',
    offset: '+09:00',
  },
  {
    id: '06f0bb3e-5c4c-44b9-8563-643f1ee725c9',
    name: 'Kwajalein',
    offset: '+12:00',
  },
  {
    id: '32b48d00-3c53-4652-8c38-8bf319a841d2',
    name: 'Libya',
    offset: '+02:00',
  },
  {
    id: 'ced5f386-1961-4a0c-a520-567b87b1b1c2',
    name: 'MET',
    offset: '+02:00',
  },
  {
    id: '4d3f3606-a5d3-4dbf-a12d-dc6f9c273b78',
    name: 'MST',
    offset: '-0-7:00',
  },
  {
    id: '3767b3a0-21df-4a8e-96cd-796c9a244d04',
    name: 'MST7MDT',
    offset: '-0-6:00',
  },
  {
    id: '895e897a-a4a8-4c26-838f-452daa54f1f0',
    name: 'Mexico/BajaNorte',
    offset: '-0-7:00',
  },
  {
    id: '50e835ea-bd41-4ec7-9add-943d8b2414fd',
    name: 'Mexico/BajaSur',
    offset: '-0-6:00',
  },
  {
    id: 'eb3bb976-6bcb-4a30-adc5-d586369970d4',
    name: 'Mexico/General',
    offset: '-0-5:00',
  },
  {
    id: '3cb5e31a-733b-421b-b947-254a808e4738',
    name: 'NZ',
    offset: '+13:00',
  },
  {
    id: '2b438e67-cdfd-4b7d-a220-690a2092b669',
    name: 'NZ-CHAT',
    offset: '+13:45',
  },
  {
    id: 'f5bb3b10-62d0-4552-8abc-93b95995afa9',
    name: 'Navajo',
    offset: '-0-6:00',
  },
  {
    id: 'cdc3595b-9be4-4351-8c97-68892ce017f4',
    name: 'PRC',
    offset: '+08:00',
  },
  {
    id: '7db441b0-3c3f-4f77-8a58-bc992d2f4e8d',
    name: 'PST8PDT',
    offset: '-0-7:00',
  },
  {
    id: '6d3a3cd5-247e-423c-88be-bf0b20c4612b',
    name: 'Pacific/Apia',
    offset: '+14:00',
  },
  {
    id: 'e4f639e9-579a-40e2-8fdf-793edb069542',
    name: 'Pacific/Auckland',
    offset: '+13:00',
  },
  {
    id: '5641623b-83e2-47ec-b107-a796d00f26da',
    name: 'Pacific/Bougainville',
    offset: '+11:00',
  },
  {
    id: '52346b9c-6d5f-4db1-9ff2-9f34a5b0b691',
    name: 'Pacific/Chatham',
    offset: '+13:45',
  },
  {
    id: '1b05c801-373d-40a2-b5ef-18f13ec795cc',
    name: 'Pacific/Chuuk',
    offset: '+10:00',
  },
  {
    id: '72a88473-2bab-45de-987f-2a23e3259a68',
    name: 'Pacific/Easter',
    offset: '-0-5:00',
  },
  {
    id: '30d46df3-69d0-4120-bdab-c1bc06f02aaa',
    name: 'Pacific/Efate',
    offset: '+11:00',
  },
  {
    id: 'd106d4d1-1ca8-4bb3-b2f4-7c81c8bcff32',
    name: 'Pacific/Enderbury',
    offset: '+13:00',
  },
  {
    id: '4080eae2-286f-477e-bbd6-3880e64a3752',
    name: 'Pacific/Fakaofo',
    offset: '+13:00',
  },
  {
    id: 'a984272b-139c-4313-8f2d-0475e3ae5a70',
    name: 'Pacific/Fiji',
    offset: '+12:00',
  },
  {
    id: 'b803f2fa-4940-46bc-a04d-ceec51123010',
    name: 'Pacific/Funafuti',
    offset: '+12:00',
  },
  {
    id: 'afcc27ee-40bc-4aef-8472-ca21332ab3e1',
    name: 'Pacific/Galapagos',
    offset: '-0-6:00',
  },
  {
    id: '2e05e2f3-8e28-49a7-863c-664a21a49a81',
    name: 'Pacific/Gambier',
    offset: '-0-9:00',
  },
  {
    id: '72c7dc1c-bcaf-4aa9-b5d5-1dd43092ac89',
    name: 'Pacific/Guadalcanal',
    offset: '+11:00',
  },
  {
    id: '362cf406-45e7-4367-b226-5ffa10fa9b51',
    name: 'Pacific/Guam',
    offset: '+10:00',
  },
  {
    id: '0454897a-66b8-4679-af00-f279ae1977c9',
    name: 'Pacific/Honolulu',
    offset: '-0-10:00',
  },
  {
    id: '8b8bf0e4-8db8-42ea-98d1-e8165541d300',
    name: 'Pacific/Johnston',
    offset: '-0-10:00',
  },
  {
    id: '2b7d8106-24b2-4e33-a3c7-c1816faa4316',
    name: 'Pacific/Kiritimati',
    offset: '+14:00',
  },
  {
    id: '470974e4-6b4a-4e95-a0fd-e50654aaf4aa',
    name: 'Pacific/Kosrae',
    offset: '+11:00',
  },
  {
    id: 'e65a02b7-9e40-41af-a478-c514340073d4',
    name: 'Pacific/Kwajalein',
    offset: '+12:00',
  },
  {
    id: '1a8004e5-b161-4f89-b10a-0b3c923e3e81',
    name: 'Pacific/Majuro',
    offset: '+12:00',
  },
  {
    id: '0428d94f-35ee-4fc3-9e11-1bc4fb11bbdb',
    name: 'Pacific/Marquesas',
    offset: '-0-10:30',
  },
  {
    id: 'bcace884-b68f-4f3f-852c-3da7b048e94d',
    name: 'Pacific/Midway',
    offset: '-0-11:00',
  },
  {
    id: 'fd6791ec-6546-42be-917f-bfb7839a828e',
    name: 'Pacific/Nauru',
    offset: '+12:00',
  },
  {
    id: '16490540-a3d3-4679-9dbb-b8ff75793daf',
    name: 'Pacific/Niue',
    offset: '-0-11:00',
  },
  {
    id: 'ada22ffb-efe0-432a-9e89-b42c8e033f0f',
    name: 'Pacific/Norfolk',
    offset: '+12:00',
  },
  {
    id: '25c738b3-dda7-46f3-a1c1-76f9d1735960',
    name: 'Pacific/Noumea',
    offset: '+11:00',
  },
  {
    id: '326000ff-3fc4-4c7c-89f5-8baa9801b4da',
    name: 'Pacific/Pago_Pago',
    offset: '-0-11:00',
  },
  {
    id: '8a46ac4d-eb96-4a62-bdda-aef715a3b635',
    name: 'Pacific/Palau',
    offset: '+09:00',
  },
  {
    id: 'd405f9bf-a84d-42d1-9d19-377257a3b0ab',
    name: 'Pacific/Pitcairn',
    offset: '-0-8:00',
  },
  {
    id: 'd2db2fb1-f1ba-43ca-856e-bdde8451c5f4',
    name: 'Pacific/Pohnpei',
    offset: '+11:00',
  },
  {
    id: '8a99a6db-11e1-4660-8790-0d39a0c1476c',
    name: 'Pacific/Ponape',
    offset: '+11:00',
  },
  {
    id: 'cf19aaed-4612-4dd9-aab6-16adb8d5a9fc',
    name: 'Pacific/Port_Moresby',
    offset: '+10:00',
  },
  {
    id: '9f9f06e5-7de2-43a7-b884-80634134a655',
    name: 'Pacific/Rarotonga',
    offset: '-0-10:00',
  },
  {
    id: '760d06e2-8079-4758-9b25-46b3b0191b85',
    name: 'Pacific/Saipan',
    offset: '+10:00',
  },
  {
    id: '0d0102a6-10e4-47cf-8b16-518825d27678',
    name: 'Pacific/Samoa',
    offset: '-0-11:00',
  },
  {
    id: 'b1ad1ced-b357-4d92-abce-6119beb4aad1',
    name: 'Pacific/Tahiti',
    offset: '-0-10:00',
  },
  {
    id: '2b4c1453-6289-4916-82c2-5549d78988ef',
    name: 'Pacific/Tarawa',
    offset: '+12:00',
  },
  {
    id: 'd5a29b98-16b4-49cd-90d6-8b76369b380e',
    name: 'Pacific/Tongatapu',
    offset: '+13:00',
  },
  {
    id: '8bc2553d-62f7-4281-86c3-3b3312c46559',
    name: 'Pacific/Truk',
    offset: '+10:00',
  },
  {
    id: '4e972e75-9bbb-478b-a180-e05e7be6815a',
    name: 'Pacific/Wake',
    offset: '+12:00',
  },
  {
    id: '7047c9b4-afbb-4c0d-8a3c-8c520e061877',
    name: 'Pacific/Wallis',
    offset: '+12:00',
  },
  {
    id: 'aa1d6223-3639-4357-acb2-4ee104649268',
    name: 'Pacific/Yap',
    offset: '+10:00',
  },
  {
    id: '838a5cbd-d30b-4b8f-aa73-6097cc8578b1',
    name: 'Poland',
    offset: '+02:00',
  },
  {
    id: 'c0e6a371-9508-44af-8f5f-daa631bc3d64',
    name: 'Portugal',
    offset: '+01:00',
  },
  {
    id: 'e10a3b20-16d4-46a6-83b7-b4e41fae7424',
    name: 'ROC',
    offset: '+08:00',
  },
  {
    id: '1b5415c2-088e-4da0-bb31-5739881dd0a1',
    name: 'ROK',
    offset: '+09:00',
  },
  {
    id: 'a9f01d41-e1f6-4526-9b27-3dddbafbf5f7',
    name: 'Singapore',
    offset: '+08:00',
  },
  {
    id: 'a93b868a-4949-4a14-9e26-719de3c3d484',
    name: 'Turkey',
    offset: '+03:00',
  },
  {
    id: '22fdba9b-082c-469a-a1b3-08e730a0faac',
    name: 'UCT',
    offset: '+00:00',
  },
  {
    id: '145c90e5-a265-4a70-81d1-c69c3b5e74b4',
    name: 'US/Alaska',
    offset: '-0-8:00',
  },
  {
    id: 'b418a8e1-cf58-46e3-871f-5ba6bd9549f2',
    name: 'US/Aleutian',
    offset: '-0-9:00',
  },
  {
    id: '8e547bc4-ed53-4ff4-9a2e-9c263abdc551',
    name: 'US/Arizona',
    offset: '-0-7:00',
  },
  {
    id: '8a988fe5-eab9-482f-b8a6-d7487fb764d0',
    name: 'US/Central',
    offset: '-0-5:00',
  },
  {
    id: '849ed49a-8700-43d1-a0e5-c9f36b1d66d6',
    name: 'US/East-Indiana',
    offset: '-0-4:00',
  },
  {
    id: '071eb569-e05b-4df2-99b4-ef2d18b3726d',
    name: 'US/Eastern',
    offset: '-0-4:00',
  },
  {
    id: 'f824f4ac-7b2f-441e-9f13-ca543025ef63',
    name: 'US/Hawaii',
    offset: '-0-10:00',
  },
  {
    id: '07e17c3c-b84d-4a18-8f1f-357e0c1b1a27',
    name: 'US/Indiana-Starke',
    offset: '-0-5:00',
  },
  {
    id: '8bc149e0-2fca-4e1e-9241-f368079030e2',
    name: 'US/Michigan',
    offset: '-0-4:00',
  },
  {
    id: '85b0ce7d-6572-4e99-8a7e-26bae7c9ba2e',
    name: 'US/Mountain',
    offset: '-0-6:00',
  },
  {
    id: '50c34683-e0df-45ac-afb6-b311b9169745',
    name: 'US/Pacific',
    offset: '-0-7:00',
  },
  {
    id: '18287f99-5e90-4248-b512-35dd962f91eb',
    name: 'US/Samoa',
    offset: '-0-11:00',
  },
  {
    id: '78d804e8-fd83-4d24-9946-3700c05b4efd',
    name: 'UTC',
    offset: '+00:00',
  },
  {
    id: '4892df55-017e-49c4-8bf2-2659eca177ec',
    name: 'Universal',
    offset: '+00:00',
  },
  {
    id: 'e961690a-96cc-4c77-8f09-3443cf81dc0b',
    name: 'W-SU',
    offset: '+03:00',
  },
  {
    id: '7b1d8da3-b5e9-4220-b913-c3d5e6997585',
    name: 'WET',
    offset: '+01:00',
  },
  {
    id: 'cb5d3ed0-2b7c-4f88-b1af-c9d24540e8a7',
    name: 'Zulu',
    offset: '+00:00',
  },
]
